import { html } from 'lit'

/**
 * ADRESY IKON UŻYWANYCH WE WSZYSTKICH KARTACH
 * --------------------------------------------
 * Wklej bezpośredni, publiczny adres HTTPS pomiędzy apostrofy.
 * Pozostawienie pustego adresu zachowuje wbudowaną ikonę awaryjną.
 */
export const CARD_ICON_URLS = {
  seasonWinter: 'https://coolturystki.pl/lib/wyfaqa/snowflake-outline-ffffff-sw150-msd94m8g.svg',
  seasonSpring: 'https://coolturystki.pl/lib/wyfaqa/flower-outline-ffffff-sw150-msdc9nxc.svg',
  seasonSummer: 'https://coolturystki.pl/lib/wyfaqa/sun-high-outline-ffffff-sw150-msdc9n03.svg',
  seasonAutumn: 'https://coolturystki.pl/lib/wyfaqa/leaf-outline-ffffff-sw150-msdc9otf.svg',
  group: 'https://coolturystki.pl/lib/wyfaqa/users-group-outline-1b4e5c-sw150-msd8z85b.svg',
  airport: 'https://coolturystki.pl/lib/wyfaqa/plane-tilt-outline-1b4e5c-sw150-msd91rcf.svg',
  details: 'https://coolturystki.pl/lib/wyfaqa/list-outline-1b4e5c-sw150-msd97pfl.svg',
  flight: 'https://coolturystki.pl/lib/wyfaqa/plane-outline-1b4e5c-sw150-msd9aiph.svg',
  hotel: 'https://coolturystki.pl/lib/wyfaqa/building-skyscraper-outline-1b4e5c-sw150-msd9ecdw.svg',
  pilot: 'https://coolturystki.pl/lib/wyfaqa/user-star-outline-1b4e5c-sw150-msfp5aiw.svg',
  arrow: 'https://coolturystki.pl/lib/wyfaqa/chevron-down-outline-1b4e5c-sw150-msd9m1oo.svg',
  statusAvailable: 'https://coolturystki.pl/lib/wyfaqa/circle-check-outline-48a158-sw150-msediknx.svg',
  statusLastPlaces: 'https://coolturystki.pl/lib/wyfaqa/circle-check-outline-c97323-sw150-msednxie.svg',
  statusSoldOut: 'https://coolturystki.pl/lib/wyfaqa/circle-x-outline-bd3434-sw150-msedruzr.svg',
}

export const renderCardIcon = (
  url,
  fallbackIcon,
  className = ''
) =>
  url
    ? html`<img class=${className} src=${url} alt="">`
    : fallbackIcon

export function getStatusIcon(variant) {
  if (variant === 'available') {
    return renderCardIcon(
      CARD_ICON_URLS.statusAvailable,
      html`
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="m5 12 4 4L19 6" />
        </svg>
      `
    )
  }

  if (variant === 'last-places') {
    return renderCardIcon(
      CARD_ICON_URLS.statusLastPlaces,
      html`
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2">
          <path d="m5 12 4 4L19 6" />
        </svg>
      `
    )
  }

  if (variant === 'sold-out') {
    return renderCardIcon(
      CARD_ICON_URLS.statusSoldOut,
      html`
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M6 6l12 12M18 6 6 18" />
        </svg>
      `
    )
  }

  return ''
}

export function getSeasonIconUrl(season) {
  const iconUrls = {
    winter: CARD_ICON_URLS.seasonWinter,
    spring: CARD_ICON_URLS.seasonSpring,
    summer: CARD_ICON_URLS.seasonSummer,
    autumn: CARD_ICON_URLS.seasonAutumn,
  }

  return iconUrls[season]
}

export function getSeasonFallbackIcon(season) {
  if (season === 'spring') {
    return html`
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
        <path d="M12 21V10M12 14c-4 0-7-2.5-7-6 4 0 7 2.5 7 6ZM12 11c0-4 2.5-7 6.5-7 0 4-2.5 7-6.5 7Z" />
      </svg>
    `
  }

  if (season === 'summer') {
    return html`
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
        <circle cx="12" cy="12" r="4" />
        <path d="M12 2v2M12 20v2M4.93 4.93l1.42 1.42M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.42-1.42M17.66 6.34l1.41-1.41" />
      </svg>
    `
  }

  if (season === 'autumn') {
    return html`
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
        <path d="M20 4C12 4 5 8 5 15c0 2.5 1.5 4 4 4 7 0 11-7 11-15ZM4 21c3-6 7-9 13-13" />
      </svg>
    `
  }

  return html`
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
      <path d="M12 2v20M4.2 6.5l15.6 11M19.8 6.5l-15.6 11M7 3.8l5 2.8 5-2.8M7 20.2l5-2.8 5 2.8M3.5 10l4.8 2-4.8 2M20.5 10l-4.8 2 4.8 2" />
    </svg>
  `
}
